import { createTheme } from '@mui/material';
import { colors as dizzarooColors } from '../../theme/tokens';

// Same Dizzaroo brand theme SAPEditor.jsx builds inline, hoisted so INDPage,
// INDSectionHistory and the IND editor share one instance.
const indTheme = createTheme({
  palette: {
    primary: {
      main: dizzarooColors?.primary?.[500] ?? '#1E73BE',
      light: dizzarooColors?.primary?.light ?? '#4A8FD4',
      dark: dizzarooColors?.primary?.[600] ?? '#1E6091',
      contrastText: '#ffffff',
    },
    secondary: {
      main: dizzarooColors?.accent?.teal ?? '#168AAD',
      light: dizzarooColors?.accent?.tealLight ?? '#168AAD',
      dark: dizzarooColors?.accent?.tealDark ?? '#168AAD',
      contrastText: '#ffffff',
    },
    background: { default: '#f5f5f5', paper: '#ffffff' },
  },
  typography: {
    fontFamily: '"Urbanist", "Inter", "SF Pro Display", "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
    h4: { fontFamily: '"Urbanist", sans-serif', fontWeight: 600 },
    h5: { fontFamily: '"Urbanist", sans-serif', fontWeight: 600 },
    h6: { fontFamily: '"Urbanist", sans-serif', fontWeight: 600 },
    subtitle1: { fontFamily: '"Urbanist", sans-serif', fontWeight: 500 },
    subtitle2: { fontFamily: '"Urbanist", sans-serif', fontWeight: 500 },
    button: { fontFamily: '"Urbanist", sans-serif', fontWeight: 500 },
  },
  components: {
    MuiButton: {
      defaultProps: { color: 'primary', disableElevation: true },
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 500, borderRadius: 8 },
      },
    },
    MuiPaper: { styleOverrides: { root: { boxShadow: '0 2px 4px rgba(0,0,0,0.05)' } } },
  },
});

export default indTheme;
